import { render, staticRenderFns } from "./Discount.vue?vue&type=template&id=46702157&scoped=true"
import script from "./Discount.vue?vue&type=script&lang=ts&setup=true"
export * from "./Discount.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Discount.vue?vue&type=style&index=0&id=46702157&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46702157",
  null
  
)

export default component.exports